import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut, Search, Bookmark, Building2, Bell, CreditCard, Users, Zap, Shield } from "lucide-react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const navItem = (path, label, Icon) => {
    const active = loc.pathname.startsWith(path);
    return (
      <Link
        to={path}
        data-testid={`nav-${path.replace("/", "")}-link`}
        className={`flex items-center gap-2 px-4 py-2 text-sm border-l-2 transition-colors ${
          active
            ? "border-[--accent] text-[--ink] bg-[--bg-soft]"
            : "border-transparent text-[--ink-soft] hover:text-[--ink] hover:bg-[--bg-soft]"
        }`}
      >
        <Icon size={16} strokeWidth={1.5} />
        <span>{label}</span>
      </Link>
    );
  };

  return (
    <div className="min-h-screen flex bg-[--bg]">
      <aside className="w-60 border-r border-[--line] bg-white flex flex-col">
        <div className="px-6 py-6 border-b border-[--line]">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[--ink] flex items-center justify-center">
              <Building2 size={18} className="text-white" strokeWidth={1.5} />
            </div>
            <div>
              <div className="font-display font-bold text-base leading-none">WholesaleHQ</div>
              <div className="overline mt-1">Market Recon</div>
            </div>
          </div>
        </div>
        <nav className="py-4 flex-1">
          {navItem("/dashboard", "Hunt", Search)}
          {navItem("/saved", "Saved", Bookmark)}
          {navItem("/buyers", "Buyers", Users)}
          {navItem("/sequences", "Sequences", Zap)}
          {navItem("/alerts", "Alerts", Bell)}
          {navItem("/billing", "Billing", CreditCard)}
          {user?.is_admin && navItem("/admin", "Admin", Shield)}
        </nav>
        <div className="border-t border-[--line] p-4">
          <div className="text-xs font-mono text-[--ink-muted] mb-1 truncate">
            {user?.email}
          </div>
          <div className="text-sm font-medium mb-3 truncate">{user?.full_name}</div>
          <button
            data-testid="logout-button"
            onClick={() => {
              logout();
              nav("/login");
            }}
            className="btn-ghost w-full flex items-center justify-center gap-2"
          >
            <LogOut size={14} strokeWidth={1.5} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">{children}</main>
    </div>
  );
}
